module.exports = __webpack_public_path__ + "img/image_b.4e939be6.svg";